import { render } from "./ExampleDeviceScreenImage.vue?vue&type=template&id=b81b7260&scoped=true&lang=pug"
const script = {}

import "./ExampleDeviceScreenImage.vue?vue&type=style&index=0&id=b81b7260&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81b7260"]])

export default __exports__